import { Typography } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-pro'
import { SubcontractorRequestsActionButton } from 'src/components/subcontractor-request/subcontractor-requests-table/SubcontractorRequestsActionButton'
import { colors } from 'src/theme'
import { gridFormatters, gridValueGetters } from 'src/utils/grid'

export const subcontractorRequestsColumns: Array<GridColDef> = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {params.row.id}
      </Typography>
    ),
  },
  {
    field: 'firstName',
    headerName: 'Name',
    flex: 3,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {`${params.row.firstName} ${params.row.lastName}`}
      </Typography>
    ),
  },
  {
    field: 'workState',
    headerName: 'Location',
    flex: 2,
    sortable: true,
    renderCell: (params) => {
      const { workCity, workState } = params.row
      const hasLocation = workCity && workState

      return (
        <Typography variant="body2" color={colors.SHADES_GREY_400}>
          {hasLocation ? `${workCity}, ${workState}` : <span>-</span>}
        </Typography>
      )
    },
  },
  {
    field: 'assignedAt',
    headerName: 'Invited at',
    flex: 2,
    sortable: true,
    valueGetter: gridValueGetters.parseUnixTimestamp,
    valueFormatter: gridFormatters.formatLongDate,
  },
  {
    field: 'displayName',
    headerName: 'Master Contractor',
    flex: 2,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {params.row.masterContractorName}
      </Typography>
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    sortable: false,
    renderCell: (params) => <SubcontractorRequestsActionButton subcontractorRequest={params.row} />,
  },
]

export const subcontractorRequestsPageSizeOptions = [100, 250, 500, 1000]
